import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-save-button',
  templateUrl: './save-button.component.html',
  styleUrls: ['./save-button.component.scss']
})
export class SaveButtonComponent {
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() text: string = 'Guardar';
  @Input() textLoading: string = 'Guardando...';
  @Input() color: string = 'primary';

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onClick = new EventEmitter<void>();
  
  constructor() {}
  
  onButtonClick(): void {
    if (!this.disabled && !this.loading) {
      this.onClick.emit();
    }
  }
}